// cancel-http.service.ts
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class CancelHttpService {
  private cancelPending$ = new Subject<void>();

  /** Called when route changes */
  cancelAllRequests() {
    this.cancelPending$.next();
  }

  /** Observable that all requests listen to */
  onCancelAllRequests() {
    return this.cancelPending$.asObservable();
  }
}
